export default "__VITE_ASSET__CVsCUF3o__"